/**
 * @Author : ZhuYongFang
 * @Date : 2019/8/12
 * @Version : 1.0
 * @Content : 机器人报表
 */
// import $http from '@/utils/fetch'
import $http from '@/utils/requestAxios'

export const apiRobotReport = {
  // 机器人数
  amount (query) {
    return $http.get('/robot/amount', query, {}, 'report')
  },
  // 机器人运行时长
  runTime (query) {
    return $http.get('/robot/time', query, {}, 'report')
  },
  // 机器人任务分布
  jobSpread (query) {
    return $http.get('/robot/job-spread', query, {}, 'report')
  },
  // 机器人错误分布
  failedSpread (query) {
    return $http.get('/robot/failed-spread', query, {}, 'report')
  },
  // 机器人任务数趋势堆叠图
  trend (query) {
    return $http.get('/robot/job-trend', query, {}, 'report')
  },
  // 机器人工作时间趋势堆叠图
  timeTrend (query) {
    return $http.get('/robot/trend', query, {}, 'report')
  },
  // 任务日志列表
  logs (query, page = 1, size = 10) {
    return $http.get('/robot/logs', { ...query, page, size }, {}, 'report')
  }
}
